import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { sectionAtom } from '@/atoms/section';
import { Section } from '@/types/generic';

export const useSection = (newSection: Section) => {
  const [section, setSection] = useAtom(sectionAtom);

  useEffect(() => {
    setSection(newSection);
  }, [newSection]);

  return section === newSection;
};
